import axios from 'axios';
import { AxiosError } from 'axios';
import { ApiError } from '@app/api/ApiError';
import { readToken, deleteToken } from '@app/services/localStorage.service';

export const httpApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axios.interceptors.request.use(
  function (request) {
    const tokenData = readToken();

    if (tokenData) {
      const newHeaders = {
        ...request.headers,
        'access-token': tokenData['accessToken'],
        uid: tokenData['uid'],
        client: tokenData['client'],
      };

      request = {
        ...request,
        headers: newHeaders,
      };
    }
    return request;
  },
  function (error) {
    return Promise.reject(error);
  },
);

httpApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    console.log('API Request Failed:', error.config?.url); 
    console.log('Base URL:', process.env.REACT_APP_API_URL);

    const status = error.response?.status;
    const errorMessage = error.response?.data?.message || error.message;

    if (status === 401) {
      deleteToken(); // Remove token from local storage
      //navigate('/login'); // Redirect to login page
      window.location.href = '/login';
    }

    throw new ApiError<ApiErrorData>(errorMessage, error.response?.data);
  }
);

// axios.interceptors.response.use(undefined, (error: AxiosError) => {
//   throw new ApiError<ApiErrorData>(error.response?.data?.message || error.message, error.response?.data);
// });

export interface ApiErrorData {
  message: string;
}
